module.exports = __webpack_public_path__ + "static/connect1_new-c003425e9da3727a6ec3d6b1a92eff8c.png";